import { Model } from '@/models/Model';
export class Sync extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Sync';
        this.$endpoint = '/commands/sync-42-windmills';
        this.$fillable = ['school'];
    }
}
